// extracted by mini-css-extract-plugin
export default {"block":"Loader_block__7Qvc7","img":"Loader_img__eY0ml","text":"Loader_text__QpXUf"};